(function ($) {
  const $carousel = $('#carousel');
  const $slides = $carousel.find('.slide');

  // Clone the slides and append to the end for continuous effect. Do it twice.
  for (let i = 0; i < 2; i++) {
      $slides.each(function() {
          const $clonedSlide = $(this).clone();
          $carousel.append($clonedSlide);
      });
  }

  let scrollSpeed = 1; // Pixels per frame (assuming 60fps)
  let offset = 0;

  function updateCarouselPosition() {
      offset += scrollSpeed;

      // If we've scrolled past the original set of slides (considering we duplicated them twice), reset offset
      if (offset >= $slides.first().outerWidth() * $slides.length * 2) {
          offset = 0;
      }

      $carousel.css('transform', `translateX(-${offset}px)`);
      requestAnimationFrame(updateCarouselPosition);
  }
  updateCarouselPosition();
})(jQuery);
